// 此cookie由GTM side设置，用于记录pdp页面浏览次数，计数基于pdp的GA page_view事件
// 前端代码中请勿执行写操作，仅读即可
export const pdpViewedCountPerSession = 'productPageCount';
